import React, {useState } from "react";
import axios from "axios";
import { Button, TextField, Typography, Container } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import "../style/login.scss";
import { useParams } from "react-router-dom";

function ResetPassword() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { token } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(newPassword.localeCompare(confirmPassword) !== 0){
        setError("Mots de passe non identiques")
    }
    try {
      const response = await axios.post(process.env.REACT_APP_DOMAIN_URL+"/resetPassword/", {
        token,
        newPassword,
      });
      if (response.status === 200) {
        setSuccess("Mot de passe modifié avec succès !");
        setTimeout(() => navigate("/login"), 3000);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || "Erreur de connexion au serveur");
      } else {
        setError("Erreur de connexion au serveur");
      }
    }
  };


  return (
    <Container component="main" maxWidth="xs" className="logContainer">
      <div className="logContainerChild">
        <LockOutlinedIcon sx={{ color: theme.palette.mode === 'dark' ? 'white' : 'black', fontSize: 30 }} />
        <Typography component="h1" variant="h5">
          Changer votre mot de passe
        </Typography>
        {error && <p className="error-message">{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Nouveau mot de passe"
            type="password"
            id="password"
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Confirmer le nouveau mot de passe"
            type="password"
            id="password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3 }}>
            Modifier le mot de passe
          </Button>
        </form>
      </div>
    </Container>
  );
}

export default ResetPassword;
